define(function(require) {
  const Utils = require('civicsUtils/general_utilities');

  var IpsModelCollection = require('civicsBase/ipsModelCollection');
  var IpsModel = require('civicsBase/ipsModel');
  var allowTypes = ['text','radio','checkbox','select','number']; // todo will support more input types
  // Determine what type of element this is. It
  // will either return the `type` attribute of
  // an `<input>` element, or the `tagName` of
  // the element when the element is not an `<input>`.
  var getElementType = function(el) {
    var typeAttr;
    var $el = $(el);
    var tagName = $el[0].tagName;
    var type = tagName;
    if (tagName.toLowerCase() === 'input' || tagName.toLowerCase() === 'textarea' || tagName.toLowerCase() === 'select' ) {
      typeAttr = $el.attr('type');
      if (typeAttr) {
        type = typeAttr;
      } else {
        type = 'text';
      }
    }
    return type;
  };

  var _getValidation = function(output, element) {
    if ( element['elements'] && _.isArray(element['elements']) && element['elements'].length > 0 ){
      _.forEach(element['elements'], o=>{
        if ( element['bind'] && element['bind'].trim().length > 0)
        {
          if ( !output[element['bind']] ){
            output[element['bind']] = {};
          }
          _getValidation(output[element['bind']],o);
        }
        else{
          _getValidation(output, o);
        }
      })
    }
    else if ( element['bind'] && element['bind'].trim().length > 0){
      var binds = element['bind'].split('.');
      if (_.isArray(binds) && binds.length > 1){
        if ( !output[binds[0]] ){
          output[binds[0]] = {};
        }
        element.bind = element.bind.substring(element.bind.indexOf('.')+1);
        _getValidation(output[binds[0]],element);
      }
      else {
        output[element['bind']]={required:true} ;
      }
    }
  };

  var _traverseDocument = function(output, element, prefix, keyOnly) {
    if ( element['elements'] && _.isArray(element['elements']) && element['elements'].length > 0 ){
      _.forEach(element['elements'], o=>{
          _traverseDocument(output, o, element['bind'], keyOnly);
      })
    }
    else if ( element['bind'] && element['bind'].trim().length > 0){
      if ( prefix ){
        prefix = prefix + '.'
      }
      else {
        prefix = '';
      }
      if ( !(keyOnly === true) ||  (element['isKeyValue'] &&  element['isKeyValue'] === true) ){
        output.push(prefix + element['bind'] );
      }
    }
  };

  var _stripBindForRootTable = function ( element ){
    if ( element['type'] && element['type'] == 'Table'){
      element['bind'] = '';
      return;
    }
    else if ( element['elements'] && _.isArray(element['elements']) && element['elements'].length > 0 ){
      _.forEach(element['elements'], o=>{
          _stripBindForRootTable( o );
      })
    }
    else {
      return;
    }
  };

  var _getTablesFromView = function(view){
    var tables;
    if (_.isUndefined(view.$el)) {
      tables = $(view).find('table');
    } else {
      tables= view.$el.find('table');
    }
    return tables;
  };

  var _getInputsFromView = function(view){
    var formInputs;
    if (_.isUndefined(view.$el)) {
      formInputs = $(view).find(':input',':textarea').filter(function() { return !$(this).closest('table[class="grid-table"]').length	});
    } else {
      formInputs= view.$el.find(':input',':textarea').filter(function() { return !$(this).closest('table[class="grid-table"]').length	});
    }
    if ( formInputs ){
      formInputs = _.reject(formInputs, function(el) {
        var myType = getElementType(el);
        var found = _.find(allowTypes,function(t){return t.toUpperCase() === myType.toUpperCase()});
        return !found; // if not found in the allowed types, reject it
      });
    }
    return formInputs;
  };

  var _getPsFromView = function(view){
    var ps;
    if (_.isUndefined(view.$el)) {
      ps = $(view).find('p').filter(function() { return !$(this).closest('table[class="grid-table"]').length	});
    } else {
      ps = view.$el.find('p').filter(function() { return !$(this).closest('table[class="grid-table"]').length	});
    }
    return ps;
  };

  var _convertModelToNameValuePairs = function(m){
    var o = m.toJSON();
    var pairs = [];
    _mapObjectInternal(undefined, o,pairs);
    return pairs;
  };

  var _mapObjectInternal = function(parent, o, pairs) {
    _.map(o, (val,key)=>{
      var bind = key;
      if ( parent ){
        bind = parent + '.' + key
      }

      // if the data is an array, dont flatten the values
      if ( !_.isArray(val) && _.isObject(val)){
        _mapObjectInternal(bind, val, pairs);
      }
      else if ( !key.startsWith('_')){
        pairs.push({value:val,name:bind});
      }
    });
  };

  var _fromNameValuePair = function(view, dataList){
    _handleInputs(view,dataList);
    _handleTables(view,dataList);
    _handleLabels(view,dataList);
  };

  var _handleLabels = function(view, dataList){
    var labels = $('span[name]');
    _.forEach(labels,function(label){
      var bind = _.find(dataList, function(data){return data.name.toUpperCase() === label.attributes.name.value.toUpperCase();});
      if(bind){
        if(label.getAttribute('showashtml') === 'true'){
          label.innerHTML =  Handlebars.escapeExpression(bind.value);
        } else {
          label.textContent = bind.value;
        }
      }
    });
  };

  var _handleInputs = function(view,dataList){
    var formInputs = _getInputsFromView(view);
    // now start processing the data and set the values to the input
      _.forEach(formInputs, function(formInput){
        var $formInput = $(formInput);
        var bind = _.find(dataList, function(data){
          return data.name && data.name.toUpperCase() === formInput.name.toUpperCase() && 
                    (!data['data-extendedattributes'] 
                          || (formInput.getAttribute('data-extendedattributes') && formInput.getAttribute('data-extendedattributes').toUpperCase() == data['data-extendedattributes'].toUpperCase())) });
        if ( bind ){
          if ( formInput.type.toLowerCase() == 'radio'){
            var checked = formInput.value.toLowerCase() === bind.value.toLowerCase();
            $formInput.attr('checked', checked);
            $formInput.prop('checked', checked);
          }
          if ( formInput.type.toLowerCase() == 'checkbox'){
            if ( bind.value != null && bind.value.toString().toUpperCase() == 'TRUE'){
              $formInput.attr('checked', 'checked');
              $formInput.prop('checked', 'checked');
            }
            else{
              $formInput.removeAttr('checked');
              $formInput.prop('checked', false);
            }
          }
          else if (formInput.type.toLowerCase().startsWith('select') || (formInput.type.toLowerCase()=='text' && $formInput.hasClass('droppy-input'))){
            // dont just set the value to the select
            // set the value to its hidden input instead. this will make the select to show the value in text area.
            $formInput.val(Handlebars.escapeExpression(bind.value));
            $formInput.attr('initVal', Handlebars.escapeExpression(bind.value));
            // if the form already has the option rendered ( not based on dynamic binding)
            // use the following to set the display value
            var input = $('#' + $formInput.attr('id') + '-shdo');
            var $opt = input.find('option[value="'+bind.value+'"]');
            if ( $opt.length > 0){
				      input.val($opt.text());
            }

            // droppy dropdown update
            Utils.civicsSetDropdownValue($formInput, bind.value);


          }
          else if (formInput.type.toLowerCase() == 'text' &&
            $formInput.attr('data-datatype') == "System.DateTime"){
            if ( $formInput.attr('data-formattype') && $formInput.attr('data-formattype').toLowerCase() == 'time'){
              $formInput.val( Handlebars.helpers['global:formatTime'](bind.value));
            }
            else{
              $formInput.val( Handlebars.helpers['global:formatDate'](bind.value));
            }
          }
          else {
            var formattedVal = Handlebars.helpers['global:removeHTML'](bind.value);
            $formInput.val(formattedVal);
          }
        }
      });
      var ps = _getPsFromView(view);
      _.forEach(ps, function(p){
        var $p = $(p);
        var bind = _.find(dataList, function(data){return $p.attr('name') ? data.name.toUpperCase() === $p.attr('name').toUpperCase() : false });
        if ( bind ){
        	var type = $p.attr('type');
			if(type != 'select'){
				if($p.attr('data-datatype') == 'System.DateTime'){
          var date = '';
          if ( $p.attr('data-format') && $p.attr('data-format').toUpperCase()=='DATE'){
					   date = Handlebars.helpers['global:formatDate'](bind.value);
          }
          else if($p.attr('data-format') && $p.attr('data-format').toUpperCase()=='TIME'){
            date = Handlebars.helpers['global:formatTime'](bind.value);
          } else {
            date = Handlebars.helpers['global:formatDateTime'](bind.value);
          }
					$p.text(date);
				} else {
          var formattedVal = Handlebars.helpers['global:removeHTML'](bind.value);
          if ( $p.attr("data-formattype") && $p.attr("data-formattype").toLowerCase() == "currency"){
            formattedVal  = Handlebars.helpers['global:formatMoney'](formattedVal);
          }
          else if ( $p.attr("data-decimalplaces") && parseInt($p.attr("data-decimalplaces")) >= 0 ){
            formattedVal  = parseFloat(formattedVal).toFixed(parseInt($p.attr("data-decimalplaces")));
          }
					$p.text(formattedVal);
				}
			}
        }
      });
    }


  var _handleTables = function(view,dataList){
    var tables = _getTablesFromView(view);
    // now start processing the data and set the values to the input
    if ( tables.length > 0 ){
      _.forEach(tables, table=>{
        if ( $(table).attr('name') ) {
          var bind = _.find(dataList, function(data){return data.name.toUpperCase() === $(table).attr('name').toUpperCase() });
          if ( $(table).setTableRows && bind ){
            // if the value of this table bind is bound to an empty string on purpose, clear out the table
            if ( bind.value === ''){
              $body = $(table).find('tbody');
              if($body.length >0 && $body[0].children.length > 0){
                for (var i = ($body[0].children.length-1); i >= 0; i--) {
                    $(table).removeGridRow($($body[0].children[i]));
                }
              }
            }else{
              if (_.isArray(bind.value) && bind.value.length>0){
                var dataHasKey = false;
                var keyBind;
                $(table).find('th').each((index, th) => {
                  var $th = $(th);
                  if ($th.attr('data-iskeyvalue') == 'true'){
                    keyBind = $th.attr('data-bind');
                    dataHasKey = _.has(bind.value[0], keyBind);
                  }
                });
                if(dataHasKey){
                  $(table).setTableRows(bind.value);
                }
                else{
                  _.forEach(bind.value, val=>{
                    $(table).setTableRows([val]);
                  });
                }

              }else {
                  $(table).setTableRows(bind.value);
              }
            }
          }
        }
      });
    }
  };


  return {
    getValidationFromDocument:function(doc){
      var Validation = {};
      _getValidation(Validation, doc);
      return Validation;
    },
    getKeyBindsFromDocument:function(doc,isGrid){
      var binds = [];
      //hack : if this is grid detail, strip the binds for the main table
      if (isGrid) {
        _stripBindForRootTable(doc);
      }
      _traverseDocument(binds, doc,null,true);
      return binds;
    },
    getBindsFromDocument:function(doc,isGrid){
      var binds = [];
      //hack : if this is grid detail, strip the binds for the main table
      if ( isGrid ){
        _stripBindForRootTable(doc);
      }
      _traverseDocument(binds, doc);
      return binds;
    },
    bindView: function(view, data){
      if ( data ){
        var pairs;
        if ( data instanceof IpsModelCollection ){
          // root object is a collection
          // so this view is a grid view
          pairs = [];
          pairs.push({value:data.toJSON(),name:'root'});
        }
        else if ( data instanceof IpsModel ){
          // should always expecting a single item.
          pairs = _convertModelToNameValuePairs(data);
        }
        else if ( _.isArray(data) ){
          pairs = data;
        }

        if( pairs ){
          _fromNameValuePair(view, pairs);
        }
      }
    }
  };
});
